import { UnitRate } from '@scenario/models/unit-rate.model';
import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';

export interface SelectedUnitRatesState {
  selectedUnitRates: UnitRate;
}

const initialState: SelectedUnitRatesState = {
  selectedUnitRates: {
    from: {
      id: 1,
      currency: 'EUR',
      term: 'REAL',
      realYear: 2024,
    },
    to: {
      id: 1,
      currency: 'EUR',
      term: 'REAL',
      realYear: 2024,
    },
    ratesByYear: { 2024: 1 },
  },
};

export const selectedUnitRatesSlice = createSlice({
  name: 'selectedUnitRates',
  initialState,
  reducers: {
    saveSelectedUnitRates: (state, action: PayloadAction<UnitRate>) => {
      state.selectedUnitRates = action.payload;
    },
  },
});

export const selectSelectedUnitRates = createSelector(
  (state: RootState) => state,
  (state: RootState): UnitRate => state.selectedUnitRates.selectedUnitRates,
);

export const selectSelectedNominalUnitRate = createSelector(
  [
    (state: RootState) => state.unitRates.unitRates,
    selectSelectedUnitRates,
  ],
  (unitRates, selectedUnitRate): UnitRate =>
    unitRates.find(
      unitRate =>
        unitRate.to.currency === selectedUnitRate.to.currency &&
        unitRate.to.term === 'NOMINAL',
    ) ?? selectedUnitRate,
);

export const selectEurNominalUnitRate = createSelector(
  [
    (state: RootState) => state.unitRates.unitRates,
    selectSelectedUnitRates,
  ],
  (unitRates, selectedUnitRate): UnitRate =>
    unitRates.find(
      unitRate =>
        unitRate.to.currency === 'EUR' &&
        unitRate.to.term === 'NOMINAL',
    )
    ?? unitRates.find(
      unitRate =>
        unitRate.to.currency === selectedUnitRate.to.currency &&
        unitRate.to.term === 'NOMINAL',
    )
    ?? selectedUnitRate,
);

export const { saveSelectedUnitRates } = selectedUnitRatesSlice.actions;

export default selectedUnitRatesSlice.reducer;
